import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KettoAssuredV2Component } from './ketto-assured-v2.component';
import { SharedModule } from '../../shared/shared.module';



@NgModule({
  declarations: [
    KettoAssuredV2Component
  ],
  exports: [
    KettoAssuredV2Component
  ],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class KettoAssuredV2Module { }
